import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { Link } from 'react-router-dom';

const OfferingsHeader = ({ totalCount = 0, activeCategory = 'all' }) => {
  const getCategoryTitle = (category) => {
    switch (category) {
      case 'accommodation':
        return 'Accommodation Services';
      case 'hospitality':
        return 'Hospitality & Dining';
      case 'local-products':
        return 'Local Products & Crafts';
      default:
        return 'Tourism Offerings';
    }
  };

  const getCategoryDescription = (category) => {
    switch (category) {
      case 'accommodation':
        return 'Discover authentic places to stay, from traditional guesthouses to modern hotels, all connected to our heritage trails.';
      case 'hospitality':
        return 'Experience local cuisine and hospitality at restaurants, cafes, and dining establishments along the heritage routes.';
      case 'local-products':
        return 'Support local artisans and take home unique crafts, souvenirs, and traditional products from the region.';
      default:
        return 'Connect with local businesses and services that enhance your heritage trail experience across Serbia and Montenegro.';
    }
  };

  return (
    <div className="bg-gradient-to-r from-primary to-secondary text-primary-foreground">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        <div className="max-w-4xl">
          {/* Breadcrumb */}
          <nav className="flex items-center gap-2 text-sm mb-6 opacity-90">
            <Link 
              to="/homepage" 
              className="hover:underline transition-all duration-fast"
            >
              Home
            </Link>
            <Icon name="ChevronRight" size={14} />
            <span>Tourism Offerings</span>
          </nav>

          {/* Main Content */}
          <div className="space-y-4">
            <div className="flex items-center gap-3 mb-2">
              <div className="p-2 bg-primary-foreground/20 rounded-lg">
                <Icon name="Building2" size={24} />
              </div>
              <h1 className="font-heading font-bold text-3xl lg:text-4xl">
                {getCategoryTitle(activeCategory)}
              </h1>
            </div>
            
            <p className="text-lg lg:text-xl opacity-90 leading-relaxed max-w-3xl">
              {getCategoryDescription(activeCategory)}
            </p>
            
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 pt-2">
              <div className="flex items-center gap-2 text-sm">
                <Icon name="MapPin" size={16} />
                <span className="opacity-90">
                  {totalCount} offerings available across Serbia & Montenegro
                </span>
              </div>
              
              <div className="flex items-center gap-2">
                <Button
                  variant="secondary"
                  size="sm"
                  asChild
                  iconName="Map"
                  iconPosition="left"
                  iconSize={14}
                >
                  <Link to="/heritage-interactive-map">
                    View on Map
                  </Link>
                </Button>
                
                <Button
                  variant="outline"
                  size="sm"
                  asChild
                  iconName="Route"
                  iconPosition="left"
                  iconSize={14}
                  className="border-primary-foreground/30 text-primary-foreground hover:bg-primary-foreground/10"
                >
                  <Link to="/thematic-trails-overview">
                    Explore Trails
                  </Link>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OfferingsHeader;